import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { log, errorMsg } from 'utils';

export const INVENTORY_FETCH_DATA_INIT = createAction('INVENTORY_FETCH_DATA_INIT');
export const INVENTORY_FETCH_DATA_SUCCESS = createAction(
  'INVENTORY_FETCH_DATA_SUCCESS'
);
export const INVENTORY_FETCH_DATA_FAIL = createAction('INVENTORY_FETCH_DATA_FAIL');

export const INVENTORY_DELETE_INVENTORY_INIT = createAction('INVENTORY_DELETE_INVENTORY_INIT');
export const INVENTORY_DELETE_INVENTORY_SUCCESS = createAction(
  'INVENTORY_DELETE_INVENTORY_SUCCESS'
);
export const INVENTORY_DELETE_INVENTORY_FAIL = createAction('INVENTORY_DELETE_INVENTORY_FAIL');

export const BULK_INVENTORY_DELETE_INIT = createAction('BULK_INVENTORY_DELETE_INIT');
export const BULK_INVENTORY_DELETE_SUCCESS = createAction(
  'BULK_INVENTORY_DELETE_SUCCESS'
);
export const BULK_INVENTORY_DELETE_FAIL = createAction('BULK_INVENTORY_DELETE_FAIL');

export const INVENTORY_CLEAR_DATA = createAction('INVENTORY_CLEAR_DATA');

export const INVENTORY_CREATE_INVENTORY_INIT = createAction('INVENTORY_CREATE_INVENTORY_INIT');
export const INVENTORY_CREATE_INVENTORY_SUCCESS = createAction(
  'INVENTORY_CREATE_INVENTORY_SUCCESS'
);
export const INVENTORY_CREATE_INVENTORY_FAIL = createAction('INVENTORY_CREATE_INVENTORY_FAIL');

export const INVENTORY_MODIFY_INVENTORY_INIT = createAction('INVENTORY_MODIFY_INVENTORY_INIT');
export const INVENTORY_MODIFY_INVENTORY_SUCCESS = createAction(
  'INVENTORY_MODIFY_INVENTORY_SUCCESS'
);
export const INVENTORY_MODIFY_INVENTORY_FAIL = createAction('INVENTORY_MODIFY_INVENTORY_FAIL');

export const INVENTORY_CLEAN_UP = createAction('INVENTORY_CLEAN_UP');

export const INVENTORY_CLEAR_DATA_LOGOUT = createAction('INVENTORY_CLEAR_DATA_LOGOUT');

export const INVENTORY_BULK = createAction('INVENTORY_BULK');

// added by me
export const SET_INVENTORY = createAction('SET_INVENTORY');
export const ORDER_INVENTORY = createAction('ORDER_INVENTORY');
export const PASTE_INVENTORY = createAction('PASTE_INVENTORY');

export const INVENTORY_ADD_INVENTORY_GROUP = createAction('INVENTORY_ADD_INVENTORY_GROUP');

export const fetchInventory = ({
  mediaId,
  siteId,
  categoryId,
  type,
  start,
  end,
}) => {
  return async (dispatch, getState) => {
    dispatch(INVENTORY_FETCH_DATA_INIT());
    if (mediaId) {
      let mediaData;
      try {
        mediaData = await Axios.get(`${url}/media/get`, {
          params: {
            id: mediaId,
            siteId,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(INVENTORY_FETCH_DATA_FAIL({ error }));
      }
      const media = {
        ...mediaData.data.data,
        id: mediaId,
        categoryList: [
          {
            label: mediaData.data.data?.categoryName,
            value: mediaData.data.data?.categoryId,
          },
        ],
      };
      return dispatch(
        INVENTORY_FETCH_DATA_SUCCESS({
          list: getState().inventory.list,
          media,
          categoryId,
        })
      );
    }

    if (siteId) {
      let media;
      try {
        const payload = { siteId, categoryId, type };

        // Add start and end dates to the payload if provided
        if (start) payload.start = start;
        if (end) payload.end = end;
        media = await Axios.post(`${url}/media/filter`, payload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(INVENTORY_FETCH_DATA_FAIL({ error }));
      }
      // media = media.data.data.filter((media) => media.siteId === siteId);
      return dispatch(
        INVENTORY_FETCH_DATA_SUCCESS({
          list: media.data.data,
          media: getState().inventory.media,
          categoryId,
        })
      );
    }
    return null;
  };
};

export const bulkDeleteInventory = ({ siteId, data }, cb) => {
  return async (dispatch) => {
    dispatch(BULK_INVENTORY_DELETE_INIT());

    try {
      await Axios.post(
        `${url}/media/bulk-delete`,
        {
          siteId,
          data,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        BULK_INVENTORY_DELETE_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The media was deleted.');
    cb();
    return dispatch(BULK_INVENTORY_DELETE_SUCCESS({ data }));
  };
};

export const removeInventory = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(INVENTORY_DELETE_INVENTORY_INIT());
    try {
      await Axios.post(
        `${url}/media/remove`,
        {
          id,
          siteId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        INVENTORY_DELETE_INVENTORY_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The media was removed.');
    cb();
    return dispatch(INVENTORY_DELETE_INVENTORY_SUCCESS({ id }));
  };
};

export const deleteInventory = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(INVENTORY_DELETE_INVENTORY_INIT());

    try {
      await Axios.delete(`${url}/media/delete`, {
        params: {
          id,
          siteId,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        INVENTORY_DELETE_INVENTORY_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The media was deleted.');
    cb();
    return dispatch(INVENTORY_DELETE_INVENTORY_SUCCESS({ id }));
  };
};

export const clearInventoryData = () => {
  return (dispatch) => {
    dispatch(INVENTORY_CLEAR_DATA());
  };
};

export const clearInventoryDataLogout = () => {
  return (dispatch) => {
    dispatch(INVENTORY_CLEAR_DATA_LOGOUT());
  };
};

export const createInventory = (
  {
    name,
    description,
    start,
    end,
    duration,
    file,
    urllink,
    siteId,
    categoryId,
    associatedPois,
    schedulingType = 'manual',
    schedulingIds,
    tags,
    categoryName,
    type,
    tagIds,
    categoryIds,
    dayMode,
    days,
    dates,
    color,
    eventSchedule,
    categoryList,
    screenIds,
  },
  cb
) => {
  return async (dispatch) => {
    dispatch(INVENTORY_CREATE_INVENTORY_INIT());

    const fd = new FormData();
    fd.set('path', 'media');
    fd.set('name', name);
    if (eventSchedule) fd.set('eventSchedule', eventSchedule);
    fd.set('description', description);
    if (start && end && start !== 'Invalid date' && end !== 'Invalid date') {
      fd.set('start', start);
      fd.set('end', end);
    }
    fd.set('duration', duration);
    fd.set('url', urllink);
    fd.set('siteId', siteId);
    if (categoryId) {
      fd.set('categoryId', categoryId);
      fd.set('categoryName', categoryName);
    }
    if (associatedPois) {
      fd.set('associatedPois', associatedPois);
      // fd.set('categoryName', categoryName);
    }
    fd.set('schedulingType', schedulingType);
    if (schedulingIds) fd.set('schedulingIds', JSON.stringify(schedulingIds));
    if (tags) {
      fd.set('tags', tags);
      // fd.set('categoryName', categoryName);
    }
    if (tagIds !== undefined) fd.set('tagIds', tagIds);
    if (categoryIds !== undefined) fd.set('categoryIds', categoryIds);
    if (dayMode) fd.set('dayMode', dayMode);
    if (days !== undefined) fd.set('days', days);
    if (dates !== undefined) fd.set('dates', dates);

    fd.set('type', type);
    fd.set('color', color);
    fd.set('categoryList', JSON.stringify(categoryList));
    if (screenIds) fd.set('screenIds', JSON.stringify(screenIds));
    fd.append('file', file);
    let createdInventory;
    try {
      createdInventory = await Axios.post(`${url}/mediaDirectory/upload`, fd, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
      log(createdInventory, '<<<< create mediaaa');
    } catch (error) {
      log(error.response, '<<<< error add media');

      toastr.error(
        '',
        error.response?.data?.message || 'Please fill in all required fields'
      );

      return dispatch(
        INVENTORY_CREATE_INVENTORY_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Inventory created successfully');
    if (cb) {
      cb();
    }
    return dispatch(
      INVENTORY_CREATE_INVENTORY_SUCCESS({ media: createdInventory.data.data })
    );
  };
};

export const modifyInventory = (
  {
    id,
    name,
    description,
    start,
    end,
    duration,
    categoryId,
    categoryName,
    schedulingType,
    schedulingIds,
    file,
    siteId,
    urllink,
    associatedPois,
    tags,
    eventSchedule,
    type,
    tagIds,
    categoryIds,
    dayMode,
    days,
    dates,
    color,
    screenIds,
  },
  cb
) => {
  return async (dispatch) => {
    dispatch(INVENTORY_MODIFY_INVENTORY_INIT());
    log(categoryId, dates);
    const fd = new FormData();

    fd.set('path', 'media');
    fd.set('id', id);
    fd.set('name', name);
    fd.set('url', urllink);
    fd.set('description', description);
    if (start && end && start !== 'Invalid date' && end !== 'Invalid date') {
      fd.set('start', start);
      fd.set('end', end);
    }
    if (duration) {
      fd.set('duration', duration);
    }
    if (eventSchedule) {
      fd.set('eventSchedule', eventSchedule);
    }
    fd.set('siteId', siteId);
    if (categoryId) {
      fd.set('categoryId', categoryId);
    }
    fd.set('schedulingType', schedulingType);
    if (categoryName) {
      fd.set('categoryName', categoryName);
    }
    if (schedulingIds) fd.set('schedulingIds', JSON.stringify(schedulingIds));
    if (associatedPois) {
      fd.set('associatedPois', associatedPois);
    }
    if (tags) {
      fd.set('tags', tags);
    }
    if (tagIds !== undefined) fd.set('tagIds', tagIds);
    if (categoryIds !== undefined) fd.set('categoryIds', categoryIds);
    if (dayMode) fd.set('dayMode', dayMode);
    if (days !== undefined) fd.set('days', days);
    if (dates !== undefined) fd.set('dates', dates);
    fd.set('type', type);
    fd.set('color', color);
    if (screenIds) fd.set('screenIds', JSON.stringify(screenIds));
    fd.append('file', file);
    let updateInventory;
    log(fd.toString(), 'request body');

    try {
      updateInventory = await Axios.post(`${url}/inventory/edit`, fd, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        INVENTORY_MODIFY_INVENTORY_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Inventory updated successfully');
    if (cb) {
      cb();
    }

    return dispatch(
      INVENTORY_MODIFY_INVENTORY_SUCCESS({ media: updateInventory.data.data, id })
    );
  };
};

export const bulkInventory = ({ data, siteId }) => {
  log('Im called before dispatch');
  return async (dispatch) => {
    log('Im called after dispatch');
    const mediaBulkData = await Axios.post(
      `${url}/media/bulk`,
      {
        data,
        siteId,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    );
    return dispatch(INVENTORY_BULK({ medias: mediaBulkData.data.data }));
  };
};

// added by me
export const setInventory = (media) => {
  return (dispatch) => {
    dispatch(SET_INVENTORY({ media }));
  };
};

export const orderInventory = (media) => {
  return (dispatch) => {
    dispatch(ORDER_INVENTORY({ media }));
  };
};

export const mediaCleanUp = () => (dispatch) => dispatch(INVENTORY_CLEAN_UP());

export const mediaPaste = (
  { directoryList, siteId, categoryId, categoryName },
  cb
) => {
  return async () => {
    await Axios.post(
      `${url}/media/create`,
      {
        directoryList,
        siteId,
        categoryId,
        categoryName,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    );
    cb();
  };
};

export const bulkUpdate = ({ start, end, ids, siteId }, cb) => {
  return async () => {
    await Axios.put(
      `${url}/media/bulk `,
      {
        start,
        end,
        ids,
        siteId,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    );
    cb();
  };
};

export const bulkApproval = ({ status, ids, siteId }, cb) => {
  return async () => {
    await Axios.post(
      `${url}/media/approval `,
      {
        status,
        ids,
        siteId,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    );
    cb();
  };
};

export const modifyInventory2 = (
  {
    id,
    name,
    description,
    start,
    end,
    duration,
    categoryId,
    categoryName,
    schedulingType,
    schedulingIds,
    file,
    siteId,
    urllink,
    associatedPois,
    tags,
    eventSchedule,
    type,
    days,
    dates,
    color,
    screenIds,
    grouped = [],
  },
  cb
) => {
  return async (dispatch) => {
    dispatch(INVENTORY_MODIFY_INVENTORY_INIT());

    const buildFormData = (media) => {
      const fd = new FormData();

      fd.set('path', 'media');
      fd.set('id', media.id);
      fd.set('name', media.name);
      fd.set('url', media.urllink);
      fd.set('description', media.description);

      if (
        media.start &&
        media.end &&
        media.start !== 'Invalid date' &&
        media.end !== 'Invalid date'
      ) {
        fd.set('start', media.start);
        fd.set('end', media.end);
      }

      if (media.duration) fd.set('duration', media.duration);
      if (media.eventSchedule) fd.set('eventSchedule', media.eventSchedule);

      fd.set('siteId', media.siteId);
      fd.set('schedulingType', media.schedulingType);

      if (media.categoryId) fd.set('categoryId', media.categoryId);
      if (media.categoryName) fd.set('categoryName', media.categoryName);
      if (media.schedulingIds)
        fd.set('schedulingIds', JSON.stringify(media.schedulingIds));
      if (media.associatedPois) fd.set('associatedPois', media.associatedPois);
      if (media.tags) fd.set('tags', media.tags);

      fd.set('dates', JSON.stringify(media.dates));
      fd.set('days', JSON.stringify(media.days));
      fd.set('type', media.type);
      fd.set('color', media.color);
      if (media.screenIds) fd.set('screenIds', JSON.stringify(media.screenIds));

      if (media.file) {
        fd.append('file', media.file);
      }

      return fd;
    };

    try {
      let responses = [];

      log('Grouped', grouped);

      if (grouped.length > 0) {
        responses = [];

        for (const item of grouped) {
          const res = await Axios.post(
            `${url}/inventory/edit`,
            buildFormData(item),
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                'content-type': 'multipart/form-data',
              },
            }
          );

          log('Response', res);

          responses.push(res);
        }
      } else {
        const response = await Axios.post(
          `${url}/inventory/edit`,
          buildFormData({
            id,
            name,
            description,
            start,
            end,
            duration,
            categoryId,
            categoryName,
            schedulingType,
            schedulingIds,
            file,
            siteId,
            urllink,
            associatedPois,
            tags,
            eventSchedule,
            type,
            days,
            dates,
            color,
            screenIds,
          }),
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'content-type': 'multipart/form-data',
            },
          }
        );
        responses = [response];
      }

      toastr.success('', 'Inventory updated successfully');

      if (typeof cb === 'function') {
        cb();
      }

      return dispatch(
        INVENTORY_MODIFY_INVENTORY_SUCCESS({
          media: responses.map((r) => r.data.data),
        })
      );
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ?? 'Failed to update media';

      toastr.error('', errorMessage);

      return dispatch(
        INVENTORY_MODIFY_INVENTORY_FAIL({
          error: error?.response?.data,
        })
      );
    }
  };
};

export const addInventoryGroupToBeEdited = (mediaGroup, cb) => {
  return (dispatch) => {
    dispatch(INVENTORY_ADD_INVENTORY_GROUP({ mediaGroup }));
    cb();
  };
};
